import { useEffect, useRef, useState } from "react";
import { useToasts } from "react-toast-notifications";
import moment from "moment";
import Button from "react-bootstrap/Button";

/* Components */
import AlertInputModal from "./AlertInputModal";
import TemplatesModal from "./TemplatesModal";
import LoadedTemplate from './LoadedTemplate';
import SubscriberForm from './SubscriberForm';
import SubscribersEmailActions from './SubscribersEmailActions';
import EmailForm from "./EmailForm";
import "../../styles.css";

const EmailSusPromo = () => {
    const { addToast } = useToasts();
    const editorRef = useRef(null);
    const [templates, setTemplates] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [showInputModal, setShowInput] = useState(false);
    const [showSelectModal, setShowSelect] = useState(false);
    const [isNewTemplate, setNewTemplate] = useState(false);
    const [isConfirm, setConfirm] = useState(false);
    const [emailForm, setEmailForm] = useState({
        test: '',
        subject: '',
        name: ''
    });
    const [subscriberForm, setSubscriberForm] = useState({
        id: 0,
        puid: '',
        SuRegisteredDate: moment(moment().toDate()).format('YYYY-MM-DD'),
        minPay: 4,
        maxSubscribers: 10000,
    });

    const handleSubscriberForm = (key, value) => {
        setSubscriberForm({ ...subscriberForm, [key]: value });
    };

    const handleEmailForm = (key, value) => {
        setEmailForm({ ...emailForm, [key]: value });
    };

    const handleLoadTemplate = () => {
        setShowSelect(true);
    };

    const handleSaveTemplate = () => {
        setShowInput(true);
    };

    const handleSubmitTemplate = () => {
        const { id, puid, SuRegisteredDate, minPay, maxSubscribers } = subscriberForm;
        const { subject, name } = emailForm;

        axios.post('/api/administration/template', {
            id: !isNewTemplate ? id : 0,
            name: name,
            puid: puid,
            registered_date: SuRegisteredDate,
            min_pay: minPay,
            max_subs: maxSubscribers,
            subject: subject,
            body: editorRef.current.getContent() || '<p></p>'
        })
            .then(res => {
                if (selectedTemplate) {
                    setSelectedTemplate(res.data.template);
                }
                addToast('Successfully saved new template!', { appearance: 'success', autoDismiss: true });
            })
            .catch(err => {
                handleTemplateErrors(err);
            });
    };

    const handleDeleteTemplate = (value) => {
        axios.delete(`/api/administration/template/${value.id}`)
            .then(res => {
                addToast('Successfully deleted template!', { appearance: 'success', autoDismiss: true });
            })
            .catch(err => {
                console.log(err);
                addToast('Unable to delete template!', { appearance: 'error', autoDismiss: true });
            });
    };


    const handleTemplateErrors = (err) => {
        const requiredParams = ['name', 'puid', 'registered_date', 'min_pay', 'max_subs', 'subject'];
        const error = err.response.data;
        if (err.response.status == 422) {
            requiredParams.forEach((item) => {
                if (item in error.errors) {
                    addToast(error.errors[item][0], { appearance: 'error', autoDismiss: true });
                }
            });
            return;
        } else {
            console.log(err);
            addToast('Unable to save template!', { appearance: 'error', autoDismiss: true });
        }
    };

    useEffect(() => {
        if (isConfirm)
            handleSubmitTemplate();

        setConfirm(false);
    }, [isConfirm]);

    useEffect(() => {
        if (selectedTemplate) {
            setEmailForm({
                ...emailForm,
                subject: selectedTemplate.subject,
                name: selectedTemplate.name
            });

            setSubscriberForm({
                ...subscriberForm,
                id: selectedTemplate.id,
                puid: selectedTemplate.pu_id,
                SuRegisteredDate: moment(moment(selectedTemplate.date_from).toDate()).format('YYYY-MM-DD'),
                minPay: selectedTemplate.min_pay,
                maxSubscribers: selectedTemplate.max_subs
            });
        }
    }, [selectedTemplate]);

    return (
        <div>
            <AlertInputModal
                modalTitle="Save Template"
                show={showInputModal}
                isNew={isNewTemplate}
                initialValue={selectedTemplate ? selectedTemplate.name : ''}
                setShow={setShowInput}
                setConfirm={setConfirm}
                onChangeValue={(value) => handleEmailForm('name', value)}
            />

            <TemplatesModal
                modalTitle="Load Template"
                show={showSelectModal}
                setShow={setShowSelect}
                setTemplates={setTemplates}
                templates={templates}
                onSelectTemplate={(value) => setSelectedTemplate(value)}
                onDeleteTemplate={handleDeleteTemplate}
            />

            <div className="mb-2 d-flex">
                <h3>Email SUs a PU Promo</h3>
            </div>

            <div className="mb-2">
                <Button
                    variant="primary"
                    onClick={handleLoadTemplate}>
                    Load Template
                </Button>
                <Button
                    variant="primary"
                    onClick={() => {
                        setNewTemplate(false);
                        handleSaveTemplate();
                    }}>
                    Save Template
                </Button>
                {selectedTemplate && (
                    <Button
                        variant="primary"
                        onClick={() => {
                            setNewTemplate(true);
                            handleSaveTemplate();
                        }}>
                        Save as new template
                    </Button>
                )}
            </div>

            {selectedTemplate && (
                <LoadedTemplate selectedTemplate={selectedTemplate} />
            )}

            <SubscriberForm
                handleSubscriberForm={handleSubscriberForm}
                subscriberForm={subscriberForm}
                selectedTemplate={selectedTemplate}
            />

            <SubscribersEmailActions
                handleEmailForm={handleEmailForm}
                emailForm={emailForm}
                subscriberForm={subscriberForm}
                selectedTemplate={selectedTemplate}
                setSelectedTemplate={setSelectedTemplate}
                editorRef={editorRef}
            />

            <EmailForm
                emailForm={emailForm}
                handleEmailForm={handleEmailForm}
                editorRef={editorRef}
                selectedTemplate={selectedTemplate}
            />
        </div>
    );
};

export default EmailSusPromo;
